import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/tipos-documento'
class TipoModeloDocumentoApiClient {
	async buscarTiposModelosDocumentosAtivos(filtro) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/ativos`,
			filters: filtro,
		}).build()

		const { data } = await axios.get(url)
		return data
	}

	async buscarTiposModeloDocumentoListagemPaginada(paginacao, filtro) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		const { data } = await axios.get(url)
		return data
	}

	async criarTipoDocumento(tipoDocumento) {
		return await axios.post(URL_PATH, tipoDocumento)
	}

	async excluirTipoDocumento(idTipoDocumento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idTipoDocumento}`,
		}).build()
		return await axios.delete(url)
	}

	async editarTipoDocumento(tipoDocumento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${tipoDocumento.id}`,
		}).build()
		return await axios.put(url, tipoDocumento)
	}

	async buscarValidacoesTramitacao(idTipoDocumento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idTipoDocumento}/validacoes-tramitacao`,
		}).build()

		const { data } = await axios.get(url)
		return data
	}

	async criarValidacaoTramitacao({ idTipoDocumento, validacaoTramitacao }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idTipoDocumento}/validacoes-tramitacao`,
		}).build()
		return await axios.post(url, validacaoTramitacao)
	}

	async editarValidacaoTramitacao({ idTipoDocumento, idValidacaoTramitacao, validacaoTramitacao }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idTipoDocumento}/validacoes-tramitacao/${idValidacaoTramitacao}`,
		}).build()
		return await axios.put(url, validacaoTramitacao)
	}

	async excluirValidacaoTramitacao({ idTipoDocumento, idValidacaoTramitacao }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idTipoDocumento}/validacoes-tramitacao/${idValidacaoTramitacao}`,
		}).build()
		return await axios.delete(url)
	}
}

export default new TipoModeloDocumentoApiClient()
